import { application } from "./application"

import AiDisambiguationController from "./ai_disambiguation_controller"
import AiGenerateController from "./ai_generate_controller"
import AttachToController from "./attach_to_controller"
import AiImageController from "./ai_image_controller"
import AttachmentSelectController from "./attachment_select_controller"
import ConfirmDialogController from "./confirm_dialog_controller"
import AvatarUploadController from "./avatar_upload_controller"
import Book3dController from "./book_3d_controller"
import BookStackController from "./book_stack_controller"
import ClickableCardController from "./clickable_card_controller"
import CollectionSuggestController from "./collection_suggest_controller"
import ColorPickerController from "./color_picker_controller"
import CommentComposerController from "./comment_composer_controller"
import ContentTabsController from "./content_tabs_controller"
import CommunityHeroController from "./community_hero_controller"
import AuthorSelectController from "./author_select_controller"
import AuthorSelectorController from "./author_selector_controller"
import AuthorImageController from "./author_image_controller"
import AuthorAutoGenerateController from "./author_auto_generate_controller"
import FeaturedBookSelectorController from "./featured_book_selector_controller"
import FilterSelectController from "./filter_select_controller"
import FittextController from "./fittext_controller"
import BarcodeScannerController from "./barcode_scanner_controller"
import BookCopiesModalController from "./book_copies_modal_controller"
import BookDragDropController from "./book_drag_drop_controller"
import BoxSetReorderController from "./box_set_reorder_controller"
import BookLookupController from "./book_lookup_controller"
import BookMediaController from "./book_media_controller"
import BookSelectModeController from "./book_select_mode_controller"
import BookSelectorController from "./book_selector_controller"
import ItemSelectorController from "./item_selector_controller"
import CountdownController from "./countdown_controller"
import DashboardBlurbController from "./dashboard_blurb_controller"
import DropdownController from "./dropdown_controller"
import DuplicateGroupController from "./duplicate_group_controller"
import BookReviewWizardController from "./book_review_wizard_controller"
import BookResourcesController from "./book_resources_controller"
import StudyGroupSubjectController from "./study_group_subject_controller"
import DiscussionCommentController from "./discussion_comment_controller"
import CopyToClipboardController from "./copy_to_clipboard_controller"
import CopyLinkController from "./copy_link_controller"
import KindToggleController from "./kind_toggle_controller"
import CheckboxPickerController from "./checkbox_picker_controller"
import PublicLightboxController from "./public_lightbox_controller"
import LibraryFilterController from "./library_filter_controller"
import FavoriteToggleController from "./favorite_toggle_controller"
import FilestackController from "./filestack_controller"
import FormActionsController from "./form_actions_controller"
import FlashController from "./flash_controller"
import GraphController from "./graph_controller"
import ImageUploadController from "./image_upload_controller"
import GraphDemoController from "./graph_demo_controller"
import IsbnLookupController from "./isbn_lookup_controller"
import LibrarianChatController from "./librarian_chat_controller"
import LibraryCustomizeController from "./library_customize_controller"
import MascotViewerController from "./mascot_viewer_controller"
import LightboxController from "./lightbox_controller"
import MobileMenuController from "./mobile_menu_controller"
import ModalController from "./modal_controller"
import NavDropdownController from "./nav_dropdown_controller"
import NestedFormController from "./nested_form_controller"
import OnboardingController from "./onboarding_controller"
import OnboardingBookController from "./onboarding_book_controller"
import OrganizationPanelController from "./organization_panel_controller"
import PhotoPickerController from "./photo_picker_controller"
import PostController from "./post_controller"
import PostComposerController from "./post_composer_controller"
import PublicNavController from "./public_nav_controller"
import SidebarController from "./sidebar_controller"
import SidebarDropdownController from "./sidebar_dropdown_controller"
import SortableController from "./sortable_controller"
import TabsController from "./tabs_controller"
import ToggleController from "./toggle_controller"
import ViewToggleController from "./view_toggle_controller"
import RichtextController from "./richtext_controller"
import VideoPopupController from "./video_popup_controller"

application.register("ai-disambiguation", AiDisambiguationController)
application.register("ai-generate", AiGenerateController)
application.register("attach-to", AttachToController)
application.register("ai-image", AiImageController)
application.register("attachment-select", AttachmentSelectController)
application.register("author-select", AuthorSelectController)
application.register("author-selector", AuthorSelectorController)
application.register("book-3d", Book3dController)
application.register("book-stack", BookStackController)
application.register("clickable-card", ClickableCardController)
application.register("avatar-upload", AvatarUploadController)
application.register("collection-suggest", CollectionSuggestController)
application.register("color-picker", ColorPickerController)
application.register("comment-composer", CommentComposerController)
application.register("confirm-dialog", ConfirmDialogController)
application.register("community-hero", CommunityHeroController)
application.register("content-tabs", ContentTabsController)
application.register("author-image", AuthorImageController)
application.register("author-auto-generate", AuthorAutoGenerateController)
application.register("featured-book-selector", FeaturedBookSelectorController)
application.register("filter-select", FilterSelectController)
application.register("fittext", FittextController)
application.register("barcode-scanner", BarcodeScannerController)
application.register("book-copies-modal", BookCopiesModalController)
application.register("book-drag-drop", BookDragDropController)
application.register("box-set-reorder", BoxSetReorderController)
application.register("book-lookup", BookLookupController)
application.register("book-media", BookMediaController)
application.register("book-select-mode", BookSelectModeController)
application.register("book-selector", BookSelectorController)
application.register("item-selector", ItemSelectorController)
application.register("countdown", CountdownController)
application.register("dashboard-blurb", DashboardBlurbController)
application.register("dropdown", DropdownController)
application.register("duplicate-group", DuplicateGroupController)
application.register("book-review-wizard", BookReviewWizardController)
application.register("book-resources", BookResourcesController)
application.register("study-group-subject", StudyGroupSubjectController)
application.register("discussion-comment", DiscussionCommentController)
application.register("copy-to-clipboard", CopyToClipboardController)
application.register("copy-link", CopyLinkController)
application.register("kind-toggle", KindToggleController)
application.register("checkbox-picker", CheckboxPickerController)
application.register("public-lightbox", PublicLightboxController)
application.register("library-filter", LibraryFilterController)
application.register("favorite-toggle", FavoriteToggleController)
application.register("filestack", FilestackController)
application.register("flash", FlashController)
application.register("form-actions", FormActionsController)
application.register("graph", GraphController)
application.register("image-upload", ImageUploadController)
application.register("graph-demo", GraphDemoController)
application.register("isbn-lookup", IsbnLookupController)
application.register("librarian-chat", LibrarianChatController)
application.register("library-customize", LibraryCustomizeController)
application.register("mascot-viewer", MascotViewerController)
application.register("lightbox", LightboxController)
application.register("mobile-menu", MobileMenuController)
application.register("modal", ModalController)
application.register("nav-dropdown", NavDropdownController)
application.register("nested-form", NestedFormController)
application.register("onboarding", OnboardingController)
application.register("onboarding-book", OnboardingBookController)
application.register("organization-panel", OrganizationPanelController)
application.register("photo-picker", PhotoPickerController)
application.register("post", PostController)
application.register("post-composer", PostComposerController)
application.register("public-nav", PublicNavController)
application.register("sidebar", SidebarController)
application.register("sidebar-dropdown", SidebarDropdownController)
application.register("sortable", SortableController)
application.register("tabs", TabsController)
application.register("toggle", ToggleController)
application.register("view-toggle", ViewToggleController)
application.register("richtext", RichtextController)
application.register("video-popup", VideoPopupController)
